module.exports = __webpack_public_path__ + "media/wafoo1.0c9898b1.mp3";